export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8199.74e00766.jpg";